import React from 'react';
import moment from 'moment';
import { Draggable } from 'react-beautiful-dnd';

const MatchDndCard = ({ match, matchDetails, index, timeZone, currentMatch, isSourceCard }) => {
    const formatName = (name) => {
        return name ? `${name.charAt(0)}. ${name.split(' ')[1]}` : '';
    };

    const formattedDate = moment.utc(match.date).tz(timeZone.value);

    const renderTime = () => {
        if (isSourceCard) {
            if (match.includesTime) {
                if (match.notBefore) {
                    return (
                        <>{formattedDate?.format('ddd, MMM Do') || 'Unset Date'} not before {formattedDate?.format('h:mma') || 'Unset Time'}</>
                    );
                }
                return (
                    <>{formattedDate?.format('ddd, MMM Do') || 'Unset Date'} at {formattedDate?.format('h:mma') || 'Unset Time'}</>
                );
            }
            return <>{formattedDate?.format('ddd, MMM Do') || 'Unset Date'}</>;
        }
        if (match.timeLabel) {
            return <>{formattedDate?.format('ddd, MMM Do') || 'Unset Date'} - {match.timeLabel}</>;
        }
        return <>{formattedDate?.format('ddd, MMM Do') || 'Unset Date'}</>;
    };

    return (
        <Draggable
            draggableId={matchDetails.id}
            type={`match`}
            index={index}
        >
            {(provided) => (
                <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={`utr-card match-dnd-card p16 border mb8 ${currentMatch ? 'current' : ''}`}
                    ref={provided.innerRef}
                >
                    <div className="row">
                        <div className={`${isSourceCard ? 'col-7' : 'col-12'} d-block`}>
                            <div className="text-gray">
                                {renderTime()}
                            </div>
                            <div className="match-name fw500">
                                {formatName(matchDetails.position1?.name) || 'Unset Player'} vs {formatName(matchDetails.position2?.name) || 'Unset Player'}
                            </div>
                        </div>
                        {isSourceCard && (
                            <div className="col-5 jce text-teal">
                                Drag to set order
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Draggable>
    );
};

export default MatchDndCard;
